import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import {
  Box,
  Typography,
  Paper,
  Grid,
  CircularProgress,
  Backdrop,
} from '@mui/material';
import { apiClient } from '../api/apiClient';
import { format } from 'date-fns';
import { de } from 'date-fns/locale';

export default function BerufskundeDetail() {
  const { id } = useParams();
  const [berufskunde, setBerufskunde] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchBerufskunde = async () => {
      try {
        const response = await apiClient.get(`/berufskunde/${id}`);
        setBerufskunde(response.data);
      } catch (error) {
        console.error('Fehler beim Laden der Berufskunde:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchBerufskunde();
  }, [id]);

  if (isLoading) {
    return (
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    );
  }

  if (!berufskunde) {
    return (
      <Box sx={{ p: 3 }}>
        <Typography variant="h6" color="error">
          Berufskunde nicht gefunden
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ width: '100%', maxWidth: '1200px', mx: 'auto', px: { xs: 1.5, sm: 2, md: 0 }, py: { xs: 2, md: 3 } }}>
      <Typography variant="h4" gutterBottom>
        Berufskunde Details
      </Typography>

      <Paper sx={{ p: { xs: 2, md: 3 } }}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <Typography variant="subtitle2" color="text.secondary">
              Aktenzeichen
            </Typography>
            <Typography variant="body1" paragraph>
              {berufskunde.aktenzeichen}
            </Typography>
          </Grid>

          <Grid item xs={12} md={6}>
            <Typography variant="subtitle2" color="text.secondary">
              Kategorie
            </Typography>
            <Typography variant="body1" paragraph>
              {berufskunde.kategorie}
            </Typography>
          </Grid>

          <Grid item xs={12} md={6}>
            <Typography variant="subtitle2" color="text.secondary">
              Gericht
            </Typography>
            <Typography variant="body1" paragraph>
              {berufskunde.gericht?.bezeichnung || '-'}
            </Typography>
          </Grid>

          <Grid item xs={12} md={6}>
            <Typography variant="subtitle2" color="text.secondary">
              Auskunftgeber
            </Typography>
            <Typography variant="body1" paragraph>
              {berufskunde.auskunftgeber}
            </Typography>
          </Grid>

          <Grid item xs={12} md={6}>
            <Typography variant="subtitle2" color="text.secondary">
              Datum
            </Typography>
            <Typography variant="body1" paragraph>
              {format(new Date(berufskunde.datum), 'dd.MM.yyyy', { locale: de })}
            </Typography>
          </Grid>

          <Grid item xs={12} md={6}>
            <Typography variant="subtitle2" color="text.secondary">
              Bundesland
            </Typography>
            <Typography variant="body1" paragraph>
              {berufskunde.land}
            </Typography>
          </Grid>

          <Grid item xs={12}>
            <Typography variant="subtitle2" color="text.secondary">
              Anfrage
            </Typography>
            <Typography variant="body1" paragraph>
              {berufskunde.anfrage}
            </Typography>
          </Grid>

          <Grid item xs={12}>
            <Typography variant="subtitle2" color="text.secondary">
              Auskunft
            </Typography>
            <Typography variant="body1" paragraph>
              {berufskunde.auskunft}
            </Typography>
          </Grid>
        </Grid>
      </Paper>
    </Box>
  );
} 